import { ApplicationConfig, importProvidersFrom, inject, provideAppInitializer, provideBrowserGlobalErrorListeners } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ManifestTranslateLoader } from './manifest-translate-loader';
import { MatIconRegistry } from '@angular/material/icon';
import { environment } from '../environments/environment';
import iconRegister from '../core/services/icon.register';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { networkErrorInterceptor } from '../core/interceptors/network-error-interceptor';
import { provideKeycloakAngular } from './pages/auth/keycloak.config';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: () => new ManifestTranslateLoader(),
          deps: [HttpClient],
        },
      })
    ),
    provideKeycloakAngular(
      {
        url: environment.keycloakUrl,
        realm: environment.keycloakRealm,
        clientId: environment.keycloakClientId,
      },
      environment.userInactivityTimeout,
      new RegExp(`^${environment.baseUrl}/api(?:/.*)?$`, 'i')
    ),
    provideHttpClient(withInterceptors([includeBearerTokenInterceptor, networkErrorInterceptor])),
    provideAppInitializer(() => iconRegister(inject(MatIconRegistry), inject(DomSanitizer))),
  ],
};
